import type { ReactNode } from 'react';

import type { StampCardStamp } from '../../../../../stores/stamp-card/types';
import { STAMP_CARD_TEST_ID_PREFIX, STAMP_CARD_WIDGET_LOGO } from '../../../constants';
import { StampCardStampsRow } from '../StampCardStampsRow/StampCardStampsRow';

import styles from './StampCardWideWidget.module.scss';

const TEST_ID_PREFIX = `${STAMP_CARD_TEST_ID_PREFIX}-widget-wide`;

interface StampCardWideWidgetProps {
  stamps: StampCardStamp[];
  target: number;
  timer?: ReactNode;
  backgroundUrl?: string | null;
  logoAssetUrl?: string | null;
  emptyStampAssetUrl?: string | null;
  filledStampAssetUrl?: string | null;
  freeStampAssetUrl?: string | null;
  lockedStampAssetUrl?: string | null;
  justStampedIndexes?: number[];
  justUnlockedIndex?: number | null;
}

export function StampCardWideWidget(props: StampCardWideWidgetProps) {
  const {
    stamps,
    target,
    timer,
    backgroundUrl,
    logoAssetUrl,
    emptyStampAssetUrl,
    filledStampAssetUrl,
    freeStampAssetUrl,
    lockedStampAssetUrl,
    justStampedIndexes,
    justUnlockedIndex,
  } = props;

  const containerStyle = backgroundUrl
    ? {
        backgroundImage: `url(${backgroundUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        border: 'none',
      }
    : undefined;

  return (
    <div className={styles.container} data-testid={TEST_ID_PREFIX} style={containerStyle}>
      <img
        alt=""
        className={styles.logo}
        data-testid={`${TEST_ID_PREFIX}-logo`}
        src={logoAssetUrl || STAMP_CARD_WIDGET_LOGO}
      />
      <div className={styles.content}>
        <StampCardStampsRow
          emptyStampAssetUrl={emptyStampAssetUrl}
          filledStampAssetUrl={filledStampAssetUrl}
          freeStampAssetUrl={freeStampAssetUrl}
          justStampedIndexes={justStampedIndexes}
          justUnlockedIndex={justUnlockedIndex}
          lockedStampAssetUrl={lockedStampAssetUrl}
          stamps={stamps}
          target={target}
          testIdPrefix={TEST_ID_PREFIX}
        />
        {timer}
      </div>
    </div>
  );
}
